export default __webpack_public_path__ + "static/media/ind8.09479af3.jpg";